const HEADER_HEIGHT = 64;
const HEADER_BORDER_WIDTH = 1;
const SHELL_CONTENT_OFFSET_PX = HEADER_HEIGHT + HEADER_BORDER_WIDTH;
export {
  HEADER_BORDER_WIDTH,
  HEADER_HEIGHT,
  SHELL_CONTENT_OFFSET_PX
};
//# sourceMappingURL=layout.js.map
